<template>
    <!-- 显示图像或者 视频 -->
    <div :style="{ height: fileSize, width: fileSize }">
        <!-- 图像 -->
        <el-image class="image" v-if="type == 'image'" :src="uri" >
        </el-image>
        <!-- 视频 -->
        <video v-else-if="type == 'video'" :src="uri">
        </video>
        <!--视频 -->
        <!-- <div>
            <i class="el-icon-search" :size="18" color="#fff"/>
        </div>  -->
        <!-- 插槽内容 -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    props:{
        // 图片地址
        uri: {
            type: String
        },
        // 图片尺寸（高度和宽度）
        fileSize: {
            type: String,
            default: '100px'
        },
        // 文件类型
        type: {
            type: String,
            default: 'image'
        }
    }
}
</script>

<style lang="scss" scoped>
    .image{
        display: block;
        width:100%;
        height: 100%;
    }
</style>